import React from 'react';

// Skiss av instruktionens försättssida medan filen hämtas. Har samma mått som
// första sidan, så att dokumentet tonar fram exakt på samma plats.
const META = [[80, 150], [95, 330], [50, 170], [50, 260], [60, 300]];

export default function PappersSkelett() {
  return (
    <div className="instr-skelett" aria-hidden="true">
      <div className="instr-skelett-ark">
        <div className="instr-ph instr-ph-ikon" />
        <div className="instr-ph instr-ph-pre" />
        <div className="instr-ph instr-ph-titel" />
        {[560, 540, 575, 310].map((b) => <div key={b} className="instr-ph instr-ph-rad" style={{ width: b }} />)}
        <div className="instr-ph-linje" />
        <div className="instr-ph-meta">
          {META.map(([a, b]) => (
            <React.Fragment key={`${a}-${b}`}>
              <div className="instr-ph" style={{ width: a }} />
              <div className="instr-ph" style={{ width: b }} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
